import React, { useState } from 'react';
import { useGetSessionUsers, useGetStats } from '../../hooks/useLiveData';
import { Button, Row, DatePicker, Tag, Empty, message, Switch } from 'antd';
import { TeamOutlined } from '@ant-design/icons';
import LiveDataView from '../../commonComponents/LiveDataView';
import DynamicModal from '../../commonComponents/DynamicModal/DynamicModal';
import PiiUsersModal from '../LivePII/PiiUsersModal';
import './index.scss';

export default function LiveOutbound() {
    const [selectedDate, setSelectedDate] = useState(null);
    const [autoReload, setAutoReload] = useState(false);
    const [usersOpen, setUsersOpen] = useState(false);
    const [users, setUsers] = useState([]);
    const { data: sessions, error, refetch, isFetched, isFetching } = useGetStats(selectedDate, 'Outbound', autoReload);
    const getUsers = useGetSessionUsers();

    const showUsers = () => {
        setUsersOpen(true);
        setUsers([]);
        getUsers
            .mutateAsync([selectedDate, 'Outbound'])
            .then(data => setUsers(data?.sessions || []))
            .catch(e => {
                message.error(e?.response?.data?.message || 'Could not load outbound users');
                setUsersOpen(false);
            });
    };

    const onChange = date => {
        console.log(date.toISOString());
        if (!!date) {
            setSelectedDate(date.toISOString());
        } else {
            setSelectedDate(null);
        }
    };

    const top_row = () => {
        return (
            <Row className="top_row" gutter={[8, 8]}>
                <div className="date_wrapper" style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 2 }}>
                    <label style={{ textAlign: 'center' }}>Select Date: </label>
                    <DatePicker onChange={onChange} style={{ width: '200px' }} size="medium" />
                </div>
                <div style={{ textAlign: 'center' }}>
                    <Tag color="#f50" style={{ padding: '1px 3px', height: '32px', fontSize: '14px', display: 'flex', alignItems: 'center' }}>
                        <span>Total Count:</span>{' '}
                        <b> {sessions?.statsData?.map(el => el?.skusCount)?.reduce((partialSum, a) => partialSum + a, 0) ?? 0}</b>
                    </Tag>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span>Auto Reload</span>
                    <Switch checked={autoReload} onChange={setAutoReload} />
                </div>
                <Button icon={<TeamOutlined />} onClick={showUsers} loading={getUsers.isLoading}>
                    Outbound users
                </Button>
            </Row>
        );
    };

    const empty_data = () => {
        return (
            <>
                {!(!!sessions && sessions?.statsData?.length > 0) && (
                    <>
                        <div className="empty_data">
                            <Empty description="No Data Found For Selected Date" />
                        </div>
                    </>
                )}
            </>
        );
    };

    const data_row = () => {
        return (
            <>
                {!isFetching && !!sessions && sessions?.statsData?.length > 0 && (
                    <div class="session-wrapper">
                        {sessions?.statsData?.map((session, ind) => (
                            <LiveDataView
                                key={session.sessionId || ind}
                                session={session}
                                index={ind}
                                isFetching={isFetching}
                                completionLabel="Packing done"
                                completionKind="pack"
                            />
                        ))}
                    </div>
                )}
            </>
        );
    };

    return (
        <>
            <div className="live-outbound-wrapper">
                {top_row()}
                {data_row()}
                {empty_data()}
            </div>
            {usersOpen && (
                <DynamicModal
                    title="Outbound users"
                    open={usersOpen}
                    closable={true}
                    close={() => setUsersOpen(false)}
                    width="80%"
                    height="70vh"
                    component={
                        <PiiUsersModal
                            loading={getUsers.isLoading}
                            groups={users}
                            firstLabel="First pack"
                            lastLabel="Last pack"
                            fileName="outbound-users"
                            emptyText="No outbound sessions for this date"
                        />
                    }
                />
            )}
        </>
    );
}
